export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"title","content":"We Are PlayStation - Jeux vidéo PlayStation, PS5, PS4, PS Vita et PS3"},{"name":"description","content":"We Are PlayStation : 25 000 avis de joueurs pour trouver le jeu qui vous correspond le plus.  Avis, discussions, astuces et bons plans à partager pour tous les joueurs."},{"property":"og:title","content":"We Are PlayStation - Jeux vidéo PlayStation, PS5, PS4, PS Vita et PS3"},{"property":"og:description","content":"We Are PlayStation : 25 000 avis de joueurs pour trouver le jeu qui vous correspond le plus.  Avis, discussions, astuces et bons plans à partager pour tous les joueurs."},{"property":"og:image","content":"https://www.weareplaystation.fr/img/og-img.jpg"},{"name":"facebook-domain-verification","content":"l3aqkdq71nqnfkbev12uiqujlros40"},{"name":"msapplication-TileColor","content":"#0089d8"},{"name":"theme-color","content":"#0089d8"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon-16x16.png"},{"rel":"icon","type":"image/png","href":"/favicon-32x32.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"mask-icon","href":"/safari-pinned-tab.png","color":"#0089d8"}],"style":[],"script":[{"type":"application/ld+json","innerHTML":{"@context":"https://schema.org","@type":"WebSite","description":"We Are PlayStation : 25 000 avis de joueurs pour trouver le jeu qui vous correspond le plus.  Avis, discussions, astuces et bons plans à partager pour tous les joueurs.","inLanguage":"fr-FR","publisher":{"@id":"undefined/#organization"}}},{"type":"application/ld+json","innerHTML":"{\"@context\":\"https://schema.org\",\"@type\":\"Organization\",\"@id\":\"undefined/#organization\",\"name\":\"We Are PlayStation\"}"}],"noscript":[],"title":"We Are PlayStation - Jeux vidéo PlayStation, PS5, PS4, PS Vita et PS3","htmlAttrs":{"lang":"fr-FR"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000